import { CanActivateFn } from '@angular/router';
import { inject } from "@angular/core";
import { AuthService } from "./auth.service";

export const authGuard: CanActivateFn = (route, state) => {
  const authService =  inject(AuthService);
  const isLoggedIn = authService.isLoggedIn();
  if (!isLoggedIn) {
    // Сторінка входу тепер на новому фронтенді (v2) — повне перезавантаження
    window.location.assign('/login');
  }

  return isLoggedIn;
};
